import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

interface ISellerContractUrl {
  pocContractSignUrl: {
    url: string
    contractId: string
  }
}

export const SELLER_CONTRACT_URL = gql`
  query sellerContractSignUrl {
    pocContractSignUrl {
      url
      contractId
    }
  }
`
export const SELLER_CONTRACT_URL_KEY = 'useSellerContractUrl'

export const useSellerContractUrl = () => {
  const {
    data: {
      pocContractSignUrl: { url: contractUrl = '', contractId = '' } = {},
    } = {},
    refetch: refetchPocContractUrl,
    isFetching: isPocContractUrlFetching,
    isError: isPocContractUrlError,
  } = useQuery<ISellerContractUrl>({
    queryKey: [SELLER_CONTRACT_URL_KEY],
    queryFn: () => client.request(SELLER_CONTRACT_URL),
    enabled: false,
    staleTime: 0,
    gcTime: 0,
  })

  return {
    refetchPocContractUrl,
    contractId,
    contractUrl,
    isPocContractUrlFetching,
    isPocContractUrlError,
  }
}
